<div class="container" *ngIf="!getLoadingState()">
  <div class="header">Téléchargement du fichier</div>
  <div class="content">
    <p>
      Votre fichier a été téléchargé, si vous ne l'avez pas reçu, cliquez sur le
      bouton « <strong>Télécharger</strong> » en bas.
    </p>
  </div>
  <div class="footer">
    <button (click)="getFileDownload($event)">
      <div
        *ngIf="loadingDownload"
        class="spinner-border text-light"
        role="status"
      >
        <span class="sr-only">Traitement...</span>
      </div>
      Télécharger
    </button>
  </div>
</div>
